/// <amd-module name="Wiki/PageRenamePanel/WorkItemsArtifactHelper" />
import { encodeUri } from "VSS/Platform/Util/Linking";
import { ILinkedArtifact } from "Wiki/PageRenamePanel/IPageRenamePanelSharedInterfaces";
import * as Resources from "Wiki/PageRenamePanel/Resources";

export const ArtifactToolName = "WorkItemTracking";
export const ArtifactTypeName = "WorkItem";

export function mapWorkItemIdToLinkedArtifact(workItemId: number): ILinkedArtifact {
    const artifact: ILinkedArtifact = {
        id: workItemId.toString(),
        tool: ArtifactToolName,
        type: ArtifactTypeName,
        linkType: "work-item-link",
        linkTypeDisplayName: Resources.WorkItems
    };
    const uri = encodeUri(artifact);

    return { ...artifact, uri };
}
